import React from "react";
import { useSelector } from "react-redux";
import { isEqual } from "lodash";
import "./index.scss"; 

const MedicareAdjudication : React.FC<any> = () => {
const remitData = useSelector(
    (state) => state["remitDetailReducer"].remitData,
    isEqual
);

const isOutpatient = useSelector(
    (state) => state["remitDetailReducer"].isOutpatient,
    isEqual
);

return(
<div style={{ marginTop: "15px"}}>
    { isOutpatient && 
        <div className="medicare-adjudication-detail-container1">
          <div className="field-detail-container">
              <div className="sub-header-field-label"><span className="mdae-data-field-label">Reimbursement Rate : </span></div>
              <div className="mdae-data-field-content">{remitData.medicareAdjudication?.reimbursementRateString}</div>
          </div>
          <div className="field-detail-container">
              <div className="sub-header-field-label"><span className="mdae-data-field-label">Claim HCPCS Payable Amount :</span></div>
              <div className="mdae-data-field-content">{remitData.medicareAdjudication?.claimHcpcsPayableAmount}</div>
          </div>
          <div className="field-detail-container">
              <div className="sub-header-field-label"><span className="mdae-data-field-label">Claim ESRD Payment Amount :</span></div>
              <div className="mdae-data-field-content">{remitData.medicareAdjudication?.claimESRDPayableAmount}</div>
          </div>
          <div className="field-detail-container">
              <div className="sub-header-field-label"><span className="mdae-data-field-label">Nonpayable Professional Component Amount :</span></div>
              <div className="mdae-data-field-content">{remitData.medicareAdjudication?.nonPayableProfessionalAmount}</div>
          </div>                            
      </div>  
    }
    { !isOutpatient && 
        <div style={{display: "flex"}}>                                
            <div className="medicare-adjudication-detail-container2" style={{width: "35%"}}>
                <div className="medicare-adjudication-container-border">
                    <div className="medicare-adjudication-header-container">
                        <span className="mdae-data-field-label">Capital Adjudication:</span>
                    </div>
                    <div className="medicare-adjudication-sub-header-container">
                        <div className="field-detail-container">
                            <div className="sub-header-field-label"><span className="mdae-data-field-label">Total PPS Capital Amount : </span></div>
                            <div className="mdae-data-field-content">{remitData.medicareAdjudication?.capitalTotalPPSCapalAmount}</div>
                        </div>
                        <div className="field-detail-container">
                            <div className="sub-header-field-label"><span className="mdae-data-field-label">Federal Specific DRG Amount : </span></div>
                            <div className="mdae-data-field-content">{remitData.medicareAdjudication?.capitalFederalSpecificDRGAmount}</div>
                        </div>
                        <div className="field-detail-container">
                            <div className="sub-header-field-label"><span className="mdae-data-field-label">Hospital Specific DRG Amount : </span></div>
                            <div className="mdae-data-field-content">{remitData.medicareAdjudication?.capitalHospitalSpecificDrgAmount}</div>
                        </div>
                        <div className="field-detail-container">
                            <div className="sub-header-field-label"><span className="mdae-data-field-label">Disproportionate Share Amount : </span></div>
                            <div className="mdae-data-field-content">{remitData.medicareAdjudication?.capitalDisproportionateShareAmount}</div>
                        </div>
                        <div className="field-detail-container">
                            <div className="sub-header-field-label"><span className="mdae-data-field-label">PPS Capital IME Amount : </span></div>
                            <div className="mdae-data-field-content">{remitData.medicareAdjudication?.ppsCapitalImeAmount}</div>
                        </div>
                        <div className="field-detail-container">
                            <div className="sub-header-field-label"><span className="mdae-data-field-label">Capital Outlier Amount : </span></div>
                            <div className="mdae-data-field-content">{remitData.medicareAdjudication?.ppsCapitalOutlierAmount}</div>
                        </div>
                        <div className="field-detail-container">
                            <div className="sub-header-field-label"><span className="mdae-data-field-label">Capital Exception Amount : </span></div>
                            <div className="mdae-data-field-content">{remitData.medicareAdjudication?.ppsCapitalExceptionAmount}</div>
                        </div>
                    </div>
                </div>
            </div>  
            <div className="medicare-adjudication-detail-container2" style={{width: "35%",paddingLeft: "15px"}}>
            <div className="medicare-adjudication-container-border">
                <div className="medicare-adjudication-header-container">
                    <span className="mdae-data-field-label">Operating Adjudication :</span>
                </div>
                <div className="medicare-adjudication-sub-header-container">
                    <div className="field-detail-container">
                        <div className="sub-header-field-label"><span className="mdae-data-field-label">Hospital Specific DRG Amount : </span></div>
                        <div className="mdae-data-field-content">{remitData.medicareAdjudication?.operationHospitalSpecificDrgAmount}</div>
                    </div>
                    <div className="field-detail-container">
                        <div className="sub-header-field-label"><span className="mdae-data-field-label">Federal Specific DRG Amount : </span></div>
                        <div className="mdae-data-field-content">{remitData.medicareAdjudication?.operationFederalSpecificDrgAmount}</div>
                    </div>                                    
                </div>
            </div>
        </div>                                                                                                                                                                         
            <div className="medicare-adjudication-detail-container2" style={{ width: "31%", paddingLeft: "15px"}}>
                <div className="field-detail-container">
                    <div className="sub-header-field-label"><span className="mdae-data-field-label">Cost Report Days : </span></div>
                    <div className="mdae-data-field-content">{remitData.medicareAdjudication?.miaCostReportDays}</div>
                </div>
                <div className="field-detail-container">
                    <div className="sub-header-field-label"><span className="mdae-data-field-label">Lifetime Psychiatric Days : </span></div>
                    <div className="mdae-data-field-content">{remitData.medicareAdjudication?.lifeTimePsychiatricdays}</div>
                </div>
                <div className="field-detail-container">
                    <div className="sub-header-field-label"><span className="mdae-data-field-label">DRG Amount : </span></div>
                    <div className="mdae-data-field-content">{remitData.medicareAdjudication?.drgAmount}</div>
                </div>
                <div className="field-detail-container">
                    <div className="sub-header-field-label"><span className="mdae-data-field-label">Disproportionate Share Amount : </span></div>
                    <div className="mdae-data-field-content">{remitData.medicareAdjudication?.disproportionateShareAmount}</div>
                </div> 
                <div className="field-detail-container">
                    <div className="sub-header-field-label"><span className="mdae-data-field-label">MSP Pass Through Amount  : </span></div>
                    <div className="mdae-data-field-content">{remitData.medicareAdjudication?.mspPassThroughAmount}</div>
                </div> 
                <div className="field-detail-container">
                    <div className="sub-header-field-label"><span className="mdae-data-field-label">Indirect Medical Expense Amount : </span></div>
                    <div className="mdae-data-field-content">{remitData.medicareAdjudication?.indirectMedicalExpenseAmount}</div>
                </div>     
                <div className="field-detail-container">
                    <div className="sub-header-field-label"><span className="mdae-data-field-label">NonPayable Professional Component Amount : </span></div>
                    <div className="mdae-data-field-content">{remitData.medicareAdjudication?.nonPayableProfessionalComponentAmount}</div>
                </div>                            
            </div>
        </div>    
    }
</div>                         
)
}

export default MedicareAdjudication;